module.exports = __webpack_public_path__ + "img/broad-logo.94d135f6.svg";